
export enum TipoRupturaProdutoEnum {
  Pdv = 'Pdv',
  Estoque = 'Estoque',
  PdvEstoque = 'PdvEstoque',
}
